import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBack = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 16.6667L11.175 15.4917L6.52502 10.8333H16.6667V9.16666H6.52502L11.175 4.50832L10 3.33332L3.33335 9.99999L10 16.6667Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowBack);
export default ForwardRef;
